"use client";

import { capitalize } from "lodash";
// import { CalendarDays } from "lucide-react";
// import moment from "moment";

// import { Button } from "@/components/ui/button";
// import { Calendar } from "@/components/ui/calendar";
// import {
//   Popover,
//   PopoverTrigger,
//   PopoverContent,
// } from "@/components/ui/popover";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectGroup,
  SelectItem,
} from "@/components/ui/select";
import * as m from "@/paraglide/messages";

export default function DatePicker({
  customDuration,
  setCustomDuration,
}: // setFrom,
// setTo,
// from,
// to,
{
  customDuration: string;
  setCustomDuration: React.Dispatch<React.SetStateAction<string>>;
  setFrom: React.Dispatch<React.SetStateAction<Date>>;
  setTo: React.Dispatch<React.SetStateAction<Date>>;
  from: Date;
  to: Date;
}) {
  return (
    <div className="flex gap-2 items-center">
      <Select
        onValueChange={(value) => {
          setCustomDuration(value);
        }}
        value={customDuration}
      >
        <SelectTrigger className="w-fit bg-background border  rounded-sm py-1 px-2">
          <SelectValue placeholder="Select duration" />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            <SelectItem value="1w">1 {capitalize(m.week())}</SelectItem>
            <SelectItem value="1m">1 {capitalize(m.month())}</SelectItem>
            <SelectItem value="1y">1 {m.year()}</SelectItem>
            <SelectItem value="5y">5 {m.years()}</SelectItem>
          </SelectGroup>
        </SelectContent>
      </Select>
      {/* <div
        className={`flex items-center gap-2 ${
          customDuration === "custom" ? "" : "hidden"
        }`}
        data-value="custom"
      >
        {m.from()}
        <div className="grid gap-2">
          <Popover>
            <PopoverTrigger asChild>
              <Button
                variant="outline"
                className="pl-3 text-left font-normal text-muted-foreground h-[36px]"
              >
                {moment(new Date(from)).format("YYYY-MM-DD")}
                <CalendarDays className="h-4 w-4 opacity-50 ml-2" />
              </Button>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0" align="start">
              <Calendar
                mode="single"
                onSelect={setFrom as any}
                selected={from}
              />
            </PopoverContent>
          </Popover>
        </div>
        {m.to()}
        <div className="grid gap-2">
          <Popover>
            <PopoverTrigger asChild>
              <Button
                variant="outline"
                className="pl-3 text-left font-normal text-muted-foreground h-[36px]"
              >
                {moment(new Date(to)).format("YYYY-MM-DD")}
                <CalendarDays className="h-4 w-4 opacity-50 ml-2" />
              </Button>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0" align="start">
              <Calendar mode="single" onSelect={setTo as any} selected={to} />
            </PopoverContent>
          </Popover>
        </div>
      </div> */}
    </div>
  );
}
